import EditOccupationModal from './EditOccupationModal';

export default EditOccupationModal;
